import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export interface LaboratoryService {
  type: string;
  category?: string;
  price: number;
  collectionMethod?: string;
  collectionPrice?: number;
  partner_id?: string;
}

export const useCreateClinicLaboratoryService = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (service: Partial<LaboratoryService>) => {
      return api.post("clinic/lab-services", {
        type: service.type,
        category: service.category,
        price: service.price,
        collection_method: service.collectionMethod,
        collection_price: service.collectionPrice,
        partner_id: service.partner_id,
      });
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "create-laboratory-service-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.laboratoryServices(),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Clinic Laboratory Service]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.laboratoryServices(),
      });

      handleErrors(res, "mutation");
    },
  });
};
